import { BentoGrid, BentoCard } from "@/components/ui/bento-grid";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  CodeIcon,
  AiChat02Icon,
  EyeIcon,
  LayoutIcon,
  TimeScheduleIcon,
  UserIcon,
} from "@hugeicons/core-free-icons";

const features = [
  {
    name: "Visual Pipeline Builder",
    description:
      "Design AI workflows with an intuitive node-based graph editor. Drag, drop, and connect modules to build powerful content pipelines visually.",
    Icon: ({ className }: { className?: string }) => (
      <HugeiconsIcon icon={CodeIcon} className={className} />
    ),
    className: "col-span-3 lg:col-span-2",
  },
  {
    name: "AI Model Chaining",
    description:
      "Chain models from OpenAI, Anthropic, Stability AI, and more into seamless multi-step workflows.",
    Icon: ({ className }: { className?: string }) => (
      <HugeiconsIcon icon={AiChat02Icon} className={className} />
    ),
    className: "col-span-3 lg:col-span-1",
  },
  {
    name: "Real-time Preview",
    description:
      "Watch outputs flow through your pipeline in real time. See results at every stage as your data moves from node to node.",
    Icon: ({ className }: { className?: string }) => (
      <HugeiconsIcon icon={EyeIcon} className={className} />
    ),
    className: "col-span-3 lg:col-span-1",
  },
  {
    name: "Template Library",
    description:
      "Get started fast with pre-built workflow templates for common content creation tasks — blog posts, social media, video scripts, and more.",
    Icon: ({ className }: { className?: string }) => (
      <HugeiconsIcon icon={LayoutIcon} className={className} />
    ),
    className: "col-span-3 lg:col-span-2",
  },
  {
    name: "Version Control",
    description:
      "Track every iteration of your pipelines. Compare outputs, revert changes, and maintain a full history of your creative process.",
    Icon: ({ className }: { className?: string }) => (
      <HugeiconsIcon icon={TimeScheduleIcon} className={className} />
    ),
    className: "col-span-3 lg:col-span-2",
    comingSoon: true,
  },
  {
    name: "Team Collaboration",
    description:
      "Share pipelines with your team. Co-edit workflows in real time and build a shared library of reusable templates.",
    Icon: ({ className }: { className?: string }) => (
      <HugeiconsIcon icon={UserIcon} className={className} />
    ),
    className: "col-span-3 lg:col-span-1",
    comingSoon: true,
  },
];

export function FeaturesBento() {
  return (
    <section className="mx-auto max-w-6xl px-6 pb-24">
      <BentoGrid className="auto-rows-[18rem] grid-cols-3 gap-4 lg:auto-rows-[20rem]">
        {features.map((feature) => (
          <BentoCard key={feature.name} {...feature} />
        ))}
      </BentoGrid>
    </section>
  );
}
